import { createAppWrapper } from "../src/common.js";
import SsoSessionNew from "@/sessions/SsoLogin.vue";

document.addEventListener("DOMContentLoaded", () => {
  createAppWrapper(SsoSessionNew);
});
